//Code taken from Auth0 tutorial
//== Imports ==//
import auth0 from 'auth0-js';

class Auth {
  constructor() {
    this.auth0 = new auth0.WebAuth({
      // the following three lines must be updated with info from Auth0 account
      domain: 'bakerc.auth0.com',
      audience: 'https://bakerc.auth0.com/userinfo',
      clientID: 'Ik8pcKF4QAFcSV7QCOIYDSj0CH2ahljb',
      redirectUri: 'http://localhost:3000/callback', //conditional for deployment?
      responseType: 'id_token',
      scope: 'openid email profile'
    });

    //ATTN: REWRITE BIND FOR ES6
    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  getProfile() { //returns profile of authenticated user
    return this.profile; //declared in this.handleAuthentication
  }

  getIdToken() { //returns idToken generated by A0 for current user; used for issuing POST requests
    return this.idToken; //declared in this.handleAuthentication
  }

  isAuthenticated() { //returns whether there is an authenticated user 
    return new Date().getTime() < this.expiresAt; //declared in this.handleAuthentication
  }

  signIn() { //initializes authentication process (sends to A0 login page)
    this.auth0.authorize(); //inherited from auth0.WebAuth?

  }

  handleAuthentication() { //called after user is redirected from A0
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => { //reads hash segment of URL to fetch user details and idToken
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        this.idToken = authResult.idToken;
        this.profile = authResult.idTokenPayload;
        console.log("authResult", authResult,
            "email", this.profile.email,
            "token", this.idToken)
        // set the time that the id token will expire at
        this.expiresAt = authResult.idTokenPayload.exp * 1000;
        resolve();
      });
    })
  }

  signOut() {
    // clear id token, profile, and expiration
    this.idToken = null;
    this.profile = null;
    this.expiresAt = null;
  }
}

const auth0Client = new Auth();
//no more than one instance of this class

export default auth0Client;